/**
 * <s-sticky-buy> — the mobile Buy now / Add to cart bar, pinned to the bottom of the screen.
 * It shows whenever the product form's own Add to cart button is off screen (above or below) and hides
 * while that button is visible, so the two never show at once. While shown it sets data-stuck and
 * publishes the bar height as --sticky-buy-height on <html> so floating buttons can move above it.
 *
 * Contract: [data-sticky-bar] inside; data-target is a selector for the in-page Add to cart button.
 */
class SStickyBuy extends HTMLElement {
  #observer;

  connectedCallback() {
    this.bar = this.querySelector('[data-sticky-bar]');
    if (!this.bar) return;
    const target = document.querySelector(this.dataset.target || '');
    if (!target || !('IntersectionObserver' in window)) {
      this.#setShown(true);
      return;
    }
    this.#observer = new IntersectionObserver(([entry]) => this.#setShown(!entry.isIntersecting));
    this.#observer.observe(target);
  }

  disconnectedCallback() {
    this.#observer?.disconnect();
    this.#setShown(false);
  }

  #setShown(shown) {
    this.toggleAttribute('data-stuck', shown);
    const root = document.documentElement;
    if (shown && window.matchMedia('(max-width: 47.99rem)').matches) {
      root.style.setProperty('--sticky-buy-height', `${this.bar.offsetHeight}px`);
    } else {
      root.style.removeProperty('--sticky-buy-height');
    }
  }
}

if (!customElements.get('s-sticky-buy')) customElements.define('s-sticky-buy', SStickyBuy);
